import { BackednResponse } from "@shared/lib/types";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IParseExportPaymentsResponse } from "@shared/lib/types/briefCampains";
import { useMemo } from "react";
import { CampaignService } from "../services/Campaign.service";

type ParsePayoutExportRequest = {
  vendorPaymentBankExportId: string;
  csv: string;
};

function toParseRows(
  data: IParseExportPaymentsResponse[] | IParseExportPaymentsResponse | undefined
): IParseExportPaymentsResponse[] {
  if (!data) return [];
  return Array.isArray(data) ? data : [data];
}

export function useParsePayoutExport() {
  const {
    mutate: parsePayoutExport,
    data,
    isLoading: isParsing,
    isSuccess: isParsed,
  } = useMutation<
    ParsePayoutExportRequest,
    BackednResponse<IParseExportPaymentsResponse[]>
  >({
    mutationFn: async (request: ParsePayoutExportRequest) => {
      return await CampaignService.parseVendorPaymentsBankVerificationExport(
        request
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: { skipInvalidation: true },
  });

  const parsedRows = useMemo(() => toParseRows(data?.data), [data]);

  return {
    parsePayoutExport,
    parsedRows,
    isParsing,
    isParsed,
  };
}
